// extracted by mini-css-extract-plugin
export var fadeInAnimation = "MobileLayout-module--fadeInAnimation--0aeb4";
export var sliderContainer = "MobileLayout-module--sliderContainer--348a8";